module.exports = __webpack_public_path__ + "img/resume_img.6753c629.png";